import { render, staticRenderFns } from "./KeySkills.vue?vue&type=template&id=61b437c9&scoped=true&"
import script from "./KeySkills.vue?vue&type=script&lang=js&"
export * from "./KeySkills.vue?vue&type=script&lang=js&"
import style0 from "./KeySkills.vue?vue&type=style&index=0&id=61b437c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b437c9",
  null
  
)

export default component.exports